import { useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { motion } from "framer-motion";

export default function CardServices2({ text, desc, img, ul1, ul2, ul3 }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative w-full overflow-hidden border-4 rounded-xl border-transparent transition-all duration-300 cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className={`w-full h-80 lg:h-96 bg-cover bg-center transition-all duration-300  ${
          isHovered ? "brightness-50 scale-105" : "brightness-100"
        }`}
        style={{ backgroundImage: `url(${img})` }}
      ></div>

      <motion.div
        animate={{ opacity: isHovered ? 1 : 0, y: isHovered ? 0 : 20 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="absolute inset-0 flex flex-col items-start justify-center bg-opacity-80 text-white text-left px-6 py-4 text-xl font-medium"
      >
        <p className="mb-3">{desc}</p>
        <ul className="list-disc pl-6 space-y-2 text-lg text-gray-300">
          <li>{ul1}</li>
          <li>{ul2}</li>
          <li>{ul3}</li>
        </ul>
      </motion.div>


      <motion.div
        animate={{ y: isHovered ? "100%" : "0%" }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="absolute bottom-0 left-0 w-full bg-red-600 text-white flex items-center justify-between px-4 py-6 "
      >
        <span className="text-lg font-bold uppercase">{text}</span>

        <motion.div animate={{ x: isHovered ? 5 : 0 }} transition={{ duration: 0.3 }}>
          <FaArrowRight className="text-xl" />
        </motion.div>
      </motion.div>
    </div>
  );
}
